// Mobiles Bottom-Sheet (UX-Vorschlag P7) — dünne Hülle um Modal.tsx
// (placement "bottom"): dasselbe Overlay, Esc-Stapel, Fokusfalle und
// Scroll-Sperre wie jeder Dialog, nur unten angedockt. Ausgelöst wird es nur
// von Knöpfen, die selbst `md:hidden` sind — Desktop bleibt unverändert.

import type { ComponentChildren } from "preact";
import { Modal } from "./Modal";

export interface BottomSheetProps {
  title: string;
  onClose: () => void;
  children: ComponentChildren;
}

export function BottomSheet(props: BottomSheetProps): preact.JSX.Element {
  return (
    <Modal title={props.title} onClose={props.onClose} placement="bottom">
      {props.children}
    </Modal>
  );
}
